import { render, staticRenderFns } from "./OrderCertificateSummary.vue?vue&type=template&id=5684f228&scoped=true&"
import script from "./OrderCertificateSummary.vue?vue&type=script&lang=js&"
export * from "./OrderCertificateSummary.vue?vue&type=script&lang=js&"
import style0 from "./OrderCertificateSummary.vue?vue&type=style&index=0&id=5684f228&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5684f228",
  null
  
)

export default component.exports